import React from 'react';

import { motion } from 'framer-motion';
import { useProgressiveLoading, Card, Spinner, H3 } from '..';

export const Loading: React.FC<{
  margin?: string | number;
  height?: string | number;
  width?: string | number;
}> = ({ margin, width, height }) => {
  const [textContent] = useProgressiveLoading();
  return (
    <motion.div
      initial={{ opacity: 0.7 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        margin,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        width,
        height,
      }}
    >
      <Card>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignSelf: 'center',
          }}
        >
          <Spinner fontSize="100px" layout="column" />
          {textContent && (
            <H3 style={{ alignSelf: 'center', marginTop: 10 }}>
              {textContent}
            </H3>
          )}
        </div>
      </Card>
    </motion.div>
  );
};
